import { Input, type InputProps } from '@/components/ui';

/**
 * Characters a Nigerian phone number can legitimately contain.
 *
 * Deliberately permissive about formatting — people type `0916 848 4980`,
 * `+234 916 848 4980` and `(0916) 848-4980`, and normaliseNigerianPhone copes
 * with all of them. What it refuses is letters, which are never part of a
 * number and only ever mean the field has the wrong thing in it.
 */
const ALLOWED = /[^\d+\s()-]/g;

/**
 * Phone field that cannot hold letters.
 *
 * Filtering on change rather than validating on submit: a member who types a
 * letter by accident finds out immediately, instead of at the end of a long
 * form. `inputMode="tel"` also gets phones to open the numeric keypad, which
 * is most of the problem on mobile.
 */
export function PhoneInput({
  value,
  onChange,
  ...props
}: Omit<InputProps, 'onChange' | 'value'> & {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <Input
      {...props}
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      value={value}
      onChange={(event) => onChange(event.target.value.replace(ALLOWED, ''))}
    />
  );
}
